export const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/v1`;

export const REVENUECAT_APP_ID = process.env.REACT_APP_REVENUECAT_APP_ID;

export const revenueCatCustomerUrl = (revenueCatId: string): string | undefined => {
  if (!REVENUECAT_APP_ID) return undefined;
  return `https://app.revenuecat.com/projects/${REVENUECAT_APP_ID}/customers/${revenueCatId}?tab=overview`;
};
